import { render, staticRenderFns } from "./WorkNotesCard.vue?vue&type=template&id=114006aa&scoped=true"
import script from "./WorkNotesCard.vue?vue&type=script&lang=js"
export * from "./WorkNotesCard.vue?vue&type=script&lang=js"
import style0 from "./WorkNotesCard.vue?vue&type=style&index=0&id=114006aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114006aa",
  null
  
)

export default component.exports